module.exports = __webpack_public_path__ + "media/images/app/collections/drop-earrings-c587c19397e627953326bf7b6c4620e9.webp";